<template>
    <div class="md-layout">
      <!-- Tabs Navigation -->
      <div class="tabs-toggle-container md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="tab-buttons" ref="tabsContainer">
          <md-button
            v-for="range in tabs"
            :key="range"
            class="md-raised"
            :class="activeTab === range ? 'md-success' : 'md-default'"
            @click="setActiveTab(range, $event)"
          >
            {{ range }}
          </md-button>
  
          <!-- Inline Timestamp next to tabs -->
          <div class="timestamp-inline">
            Časový rozsah: {{ formatTimestamp(startTimestamp) }} - {{ formatTimestamp(endTimestamp) }}
          </div>
  
          <!-- Custom Range Calendar Popup -->
          <div
            v-if="showCustomCalendar"
            class="custom-calendar-popup"
            :style="calendarPosition"
            ref="calendarPopup"
          >
          <div class="calendar-header">
            <button class="month-nav" @click="prevMonth">&lt;</button>
            <span class="month-name">
             {{ currentMonth.toLocaleString('sk-SK', { month: 'long', year: 'numeric' }) }}
            </span>
           <button class="month-nav" @click="nextMonth">&gt;</button>
          </div>

            <div class="calendar-grid">
              <div class="day-name" v-for="d in dayNames" :key="d">{{ d }}</div>
              <div
                class="calendar-day"
                v-for="day in daysInMonth"
                :key="day.date.toDateString()"
                :class="{
                  selected: isSelected(day.date),
                  inRange: isInRange(day.date),
                  today: isToday(day.date)
                }"
                @click="selectDay(day.date)"
              >
                {{ day.date.getDate() }}
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- chart card 1 -->
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
  <md-card header-animation="false" background-color="info">
    <md-card-header class="md-card-header-icon md-card-header-green">
      <div class="card-icon">
        <md-icon>bolt</md-icon>
      </div>
      
      <h4 class="title">
        Ušetrená tepelná energia z odpadu (M31+M32) - {{ ZOH }} kWh
      </h4>  
    </md-card-header>

    <md-card-content class="card-content">
      <div class="section">
        <div class="section-labels two-columns">
          <span class="left">Použitá na vykurovanie objektu: {{ m31Diff }} kWh</span>
          <span class="right">Použitá na prípravu teplej vody: {{ m32Diff }} kWh</span>
        </div>

        <div class="progress-bar-container">
          <div
            class="bar vykurovanie-lightgreen"
            :style="{ width: m31Pct + '%' }"
          ></div>
          <div
            class="bar vyrobavody-green"
            :style="{ width: m32Pct + '%' }"
          ></div>
        </div>

        <div class="section-labels two-columns small">
          <span class="left">{{ m31Pct.toFixed(2) }}%</span>
          <span class="right">{{ m32Pct.toFixed(2) }}%</span>
        </div>
      </div>
    </md-card-content>
  </md-card>
</div>
        <!-- chart card 2 -->
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
  <md-card header-animation="false" background-color="info">
    <md-card-header class="md-card-header-icon md-card-header-green">
      <div class="card-icon">
        <md-icon>bolt</md-icon>
      </div>
      
      <h4 class="title">
        Spotrebovaná tepelná energia (M31+M32+M51) - {{ OverAllEnergy }} kWh
      </h4>  
    </md-card-header>

    <md-card-content class="card-content">
      <div class="section">
        <div class="section-labels two-columns">
          <span class="left">Rekuperovaná energia: {{ ZOH }} kWh</span>
          <span class="right">Od teplárenskej spoločnosti: {{ m51Diff }} kWh</span>
        </div>

        <div class="progress-bar-container">
          <div
            class="bar vyrobavody-green"
            :style="{ width: rekuperPct + '%' }"
          ></div>
          <div
            class="bar teplarenska-red"
            :style="{ width: m51Pct + '%' }"
          ></div>
        </div>

        <div class="section-labels two-columns small">
          <span class="left">{{ rekuperPct.toFixed(2) }}%</span>
          <span class="right">{{ m51Pct.toFixed(2) }}%</span>
        </div>
      </div>
    </md-card-content>
  </md-card>
</div>
            <!-- StatsCard for data delta -->
              <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
    <md-card header-animation="false" background-color="info">
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>bar_chart</md-icon>
        </div>
        
        <h4 class="title">
          Prehľad spotrieb za dané obdobie
        </h4>  
      </md-card-header>

      <md-card-content class="card-content">

            <md-table>
            <md-table-row>
              <md-table-head>Senzor</md-table-head>
              <md-table-head>Popis</md-table-head>
              <md-table-head>Množstvo</md-table-head>
              <md-table-head></md-table-head>
            </md-table-row>

            <md-table-row>
              <md-table-cell>M31</md-table-cell>
              <md-table-cell>Množstvo tepla dodaného z odpadu na vykurovanie objektu</md-table-cell>
              <md-table-cell>{{ formatDiff(m31Diff) }}</md-table-cell>
              <md-table-cell>kWh</md-table-cell>
            </md-table-row>

            <md-table-row>
              <md-table-cell>M32</md-table-cell>
              <md-table-cell>Množstvo tepla dodaného z odpadu na prípravu teplej vody</md-table-cell>
              <md-table-cell>{{ formatDiff(m32Diff) }}</md-table-cell>
              <md-table-cell>kWh</md-table-cell>
            </md-table-row>

            <md-table-row>
              <md-table-cell>M51</md-table-cell>
              <md-table-cell>Množstvo tepla dodaného od teplárenskej spoločnosti</md-table-cell>
              <md-table-cell>{{ formatDiff(m51Diff) }}</md-table-cell>
              <md-table-cell>kWh</md-table-cell>
            </md-table-row>

            <md-table-row>
              <md-table-cell>MEL</md-table-cell>
              <md-table-cell>Množstvo elektrickej energie potrebnej na cirkuláciu tepla na vykurovanie</md-table-cell>
              <md-table-cell>{{ formatDiff(MELDiff) }}</md-table-cell>
              <md-table-cell>kWh</md-table-cell>
            </md-table-row>

            <md-table-row>
              <md-table-cell>M41</md-table-cell>
              <md-table-cell>Množstvo pitnej vody spotrebovanej na prípravu teplej vody</md-table-cell>
              <md-table-cell>{{ formatDiff(m41Diff) }}</md-table-cell>
              <md-table-cell>m³</md-table-cell>
            </md-table-row>

            <md-table-row>
              <md-table-cell>M42</md-table-cell>
              <md-table-cell>Množstvo teplej vody odobranej od teplárenskej spoločnosti</md-table-cell>
              <md-table-cell>{{ formatDiff(m42Diff) }}</md-table-cell>
              <md-table-cell>m³</md-table-cell>
            </md-table-row>
          </md-table> 
        </md-card-content>
  </md-card>
      </div>

          <!-- StatsCard for data delta -->
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
    <md-card header-animation="false" background-color="info">
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>bar_chart</md-icon>
        </div>
        
        <h4 class="title">
          Prehľad meraných teplôt za dané obdobie
        </h4>  
      </md-card-header>

      <md-card-content class="card-content">

            <md-table>
            <md-table-row>
              <md-table-head>Senzor</md-table-head>
              <md-table-head>Popis</md-table-head>
              <md-table-head>Min</md-table-head>
              <md-table-head>Max</md-table-head>
              <md-table-head>Priemer</md-table-head>
              <md-table-head></md-table-head>
            </md-table-row>

            <md-table-row>
              <md-table-cell>T103</md-table-cell>
              <md-table-cell>Teplota vychladenej odpadovej vody na výstupe objektu</md-table-cell>
              <md-table-cell>{{ t103min }}</md-table-cell>
              <md-table-cell>{{ t103max }}</md-table-cell>
              <md-table-cell>{{ t103avg }}</md-table-cell>
              <md-table-cell>°C</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>T104</md-table-cell>
              <md-table-cell>Teplota privádzanej odpadovej vody</md-table-cell>
              <md-table-cell>{{ t104min }}</md-table-cell>
              <md-table-cell>{{ t104max }}</md-table-cell>
              <md-table-cell>{{ t104avg }}</md-table-cell>
              <md-table-cell>°C</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>T411</md-table-cell>
              <md-table-cell>Teplota teplej vody dodávanej do objektu</md-table-cell>
              <md-table-cell>{{ t411min }}</md-table-cell>
              <md-table-cell>{{ t411max }}</md-table-cell>
              <md-table-cell>{{ t411avg }}</md-table-cell>
              <md-table-cell>°C</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>T600</md-table-cell>
              <md-table-cell>Teplota vonkajšieho prostredia</md-table-cell>
              <md-table-cell>{{ t600min }}</md-table-cell>
              <md-table-cell>{{ t600max }}</md-table-cell>
              <md-table-cell>{{ t600avg }}</md-table-cell>
              <md-table-cell>°C</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>T609</md-table-cell>
              <md-table-cell>Teplota vzduchu v objekte</md-table-cell>
              <md-table-cell>{{ t609min }}</md-table-cell>
              <md-table-cell>{{ t609max }}</md-table-cell>
              <md-table-cell>{{ t609avg }}</md-table-cell>
              <md-table-cell>°C</md-table-cell>
            </md-table-row>

          </md-table> 
        </md-card-content>
      </md-card>
      </div>

    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { sensors } from "@/utils/userInfo.js";
  import { StatsCard, AnimatedNumber } from "@/components";
  
  export default {
    name: "SimpleTabs",
    data() {
      return {
        tabs: ["Dnes", "Posledných 7 dní", "Posledných 30 dní", "Tento rok", "Vlastný rozsah"],
        activeTab: "Dnes",
        startTimestamp: 0,
        endTimestamp: 0,
        showCustomCalendar: false,
        calendarPosition: { top: "0px", left: "0px" },
        currentMonth: new Date(),
        dayNames: ["Po", "Ut", "St", "Št", "Pi", "So", "Ne"],
        selectedStart: null,
        selectedEnd: null,
  
        sensorResults: [],
  
        // Min/Max/Avg for multiple temperature sensors
        t103min: null, t103max: null, t103avg: null,
        t104min: null, t104max: null, t104avg: null,
        t411min: null, t411max: null, t411avg: null,
        t600min: null, t600max: null, t600avg: null,
        t609min: null, t609max: null, t609avg: null,
      };
    },
    computed: {
      daysInMonth() {
        const days = [];
        const year = this.currentMonth.getFullYear();
        const month = this.currentMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        for (let d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
          days.push({ date: new Date(d) });
        }
        return days;
      },
      m31Diff() {
        return this.getDiff("M31");
      },
      m32Diff() {
        return this.getDiff("M32");
      },
      m51Diff() {
        return this.getDiff("M51");
      },
      MELDiff() {
        return this.getDiff("MEL");
      },
      m41Diff() {
        return this.getDiff("M41");
      },
      m42Diff() {
        return this.getDiff("M42");
      },
      ZOH() {
    return this.m31Diff + this.m32Diff;
  },
  ZOP() {
    const total = this.m31Diff + this.m32Diff + this.m51Diff;
    return total > 0 ? ((this.m31Diff + this.m32Diff) / total) * 100 : 0;
  },
  OverAllEnergy() {
     return this.m31Diff+ this.m32Diff+ this.m51Diff;
  },
  m31Pct() {
      return (this.m31Diff / this.ZOH) * 100;
    },
    m32Pct() {
      return (this.m32Diff / this.ZOH) * 100;
    },
   rekuperPct() {
    return ((this.m31Diff + this.m32Diff)/ (this.OverAllEnergy)) * 100;
   },
   m51Pct(){
     return (this.m51Diff / this.OverAllEnergy) *100;
   },
    },
    async mounted() {
      this.calculateTimestamps();
      await this.fetchAllSensors();
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
      prevMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
  },
  nextMonth() {
    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
  },
      getDiff(id) {
        const sensor = this.sensorResults.find((s) => s.id === id);
        return sensor && sensor.diff !== null ? sensor.diff : null;
      },
      formatDiff(value) {
        return value !== null ? value.toFixed(2) : 0;
      },
  
      async setActiveTab(tab, event) {
        this.activeTab = tab;
        if (tab !== "Vlastný rozsah") {
          this.showCustomCalendar = false;
          this.calculateTimestamps();
          await this.fetchAllSensors();
        } else {
          this.showCustomCalendar = true;
          this.selectedStart = null;
          this.selectedEnd = null;
          this.$nextTick(() => {
            const btn = event.currentTarget;
            this.calendarPosition = {
              top: btn.offsetTop + btn.offsetHeight + "px",
              left: btn.offsetLeft + "px",
            };
          });
        }
      },
  
      calculateTimestamps() {
        const now = new Date();
        let start;
  
        switch (this.activeTab) {
          case "Dnes":
            start = new Date(now);
            start.setHours(0, 0, 0, 0);
            break;
          case "Posledných 7 dní":
            start = new Date(now);
            start.setDate(start.getDate() - 7);
            break;
          case "Posledných 30 dní":
            start = new Date(now);
            start.setDate(start.getDate() - 30);
            break;
          case "Tento rok":
            start = new Date(now.getFullYear(), 0, 1);
            break;
        }
  
        this.startTimestamp = Math.floor(start.getTime() / 1000);
        this.endTimestamp = Math.floor(now.getTime() / 1000);
      },
  
      formatTimestamp(ts) {
        const date = new Date(ts * 1000);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}.${month}.${year} (${hours}:${minutes})`;
      },
  
      async fetchAllSensors() {
        const idsToFetch = ["M31","M32","M41","M42","M51","MEL","T103","T104","T411","T600","T609","ZOH","ZOP"];
        this.sensorResults = [];
  
        // Reset temperature stats before fetching
        this.t103min = this.t103max = this.t103avg = null;
        this.t104min = this.t104max = this.t104avg = null;
        this.t411min = this.t411max = this.t411avg = null;
        this.t600min = this.t600max = this.t600avg = null;
        this.t609min = this.t609max = this.t609avg = null;
  
        for (const id of idsToFetch) {
          try {
            const response = await axios.post("https://devel.ceelabs.com/energiareal/Data.php", {
              start: this.startTimestamp,
              end: this.endTimestamp,
              deviceID: id,
            });
  
            const timeSeries = response.data.data;
            if (!timeSeries || Object.keys(timeSeries).length === 0) {
              this.sensorResults.push({ id, firstValue: null, lastValue: null, diff: null });
              continue;
            }
  
            const sortedKeys = Object.keys(timeSeries).sort((a, b) => a - b);
            const values = sortedKeys.map((k) => parseFloat(timeSeries[k]));
  
            const firstValue = values[0];
            const lastValue = values[values.length - 1];
            const diff = lastValue - firstValue;
  
            // Min/Max/Avg calculation for temperature sensors
            if (["T103", "T104", "T411", "T600", "T609"].includes(id)) {
              const min = Math.min(...values).toFixed(2);
              const max = Math.max(...values).toFixed(2);
              const avg = (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2);
  
              this[`${id.toLowerCase()}min`] = min;
              this[`${id.toLowerCase()}max`] = max;
              this[`${id.toLowerCase()}avg`] = avg;
            }
  
            this.sensorResults.push({
              id,
              firstTimestamp: parseInt(sortedKeys[0]),
              firstValue,
              lastTimestamp: parseInt(sortedKeys[sortedKeys.length - 1]),
              lastValue,
              diff,
            });
          } catch (e) {
            //console.error(`Failed to fetch data for sensor ${id}`, e);
            this.sensorResults.push({ id, firstValue: null, lastValue: null, diff: null });
          }
        }
      },
  
      selectDay(date) {
        if (!this.selectedStart || (this.selectedStart && this.selectedEnd)) {
          this.selectedStart = date;
          this.selectedEnd = null;
        } else if (date >= this.selectedStart) {
          this.selectedEnd = date;
          this.finalizeCustomRange();
        } else {
          this.selectedStart = date;
        }
      },
  
      isSelected(date) {
        return (
          (this.selectedStart && date.toDateString() === this.selectedStart.toDateString()) ||
          (this.selectedEnd && date.toDateString() === this.selectedEnd.toDateString())
        );
      },
  
      isInRange(date) {
        if (!this.selectedStart || !this.selectedEnd) return false;
        return date > this.selectedStart && date < this.selectedEnd;
      },
  
      isToday(date) {
        const now = new Date();
        return date.toDateString() === now.toDateString();
      },
  
      async finalizeCustomRange() {
        if (!this.selectedStart || !this.selectedEnd) return;
        const start = new Date(this.selectedStart);
        start.setHours(0, 0, 0, 0);
        const end = new Date(this.selectedEnd);
        end.setHours(23, 59, 59, 999);
  
        this.startTimestamp = Math.floor(start.getTime() / 1000);
        this.endTimestamp = Math.floor(end.getTime() / 1000);
  
        this.showCustomCalendar = false;
        await this.fetchAllSensors();
      },
  
      handleClickOutside(event) {
        if (
          this.showCustomCalendar &&
          !this.$refs.calendarPopup.contains(event.target) &&
          !this.$refs.tabsContainer.contains(event.target)
        ) {
          this.showCustomCalendar = false;
        }
      },
    },
  };
  </script>
    
  <style scoped>
  .section-labels.two-columns {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-labels.two-columns .left {
  text-align: left;
}

.section-labels.two-columns .right {
  text-align: right;
}

.progress-bar-container {
  display: flex;
  width: 100%;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #e5e7eb; /* light gray background */
}

.bar {
  height: 100%;
}

.vykurovanie-lightgreen { 
  background-color: rgb(32, 241, 112); /* yellow */
}

.vyrobavody-green {
  background-color: rgb(21, 167, 21); /* lighter yellow */
}

.teplarenska-red {
  background-color: rgb(241, 39, 39); /* lighter yellow */
}
  .md-table-cell,
.md-table-head {
  text-align: left !important;
}

  .tab-buttons {
    display: flex;
    gap: 8px;
    position: relative;
    align-items: center;
  }
  
  .timestamp-inline {
    font-size: 14px;
    color: #333;
    margin-left: 12px;
    white-space: nowrap;
  }
  
  .custom-calendar-popup {
    position: absolute;
    background: white;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 6px;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between; /* arrows on edges */
  font-weight: bold;
  margin-bottom: 6px;
  text-align: center;
}

.month-nav {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 6px;
}

.month-name {
  flex: 1;              /* take remaining space */
  text-align: center;    /* center text between arrows */
  white-space: nowrap;   /* prevent line breaks */
}

  
  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 30px);
    gap: 2px;
  }
  
  .day-name {
    font-weight: bold;
    text-align: center;
    font-size: 12px;
  }
  
  .calendar-day {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .calendar-day.selected {
    background: #4caf50;
    color: white;
  }
  
  .calendar-day.inRange {
    background: #a5d6a7;
  }
  
  .calendar-day.today {
    border: 1px solid #4caf50;
  }
  
  .sensor-table {
    margin-top: 16px;
  }
  
  .sensor-table table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .sensor-table th,
  .sensor-table td {
    border: 1px solid #ddd;
    padding: 6px 10px;
    text-align: left;
  }
  
  .sensor-table th {
    background: #f5f5f5;
  }
  </style>
  